import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root',
})
export class CaptchaService {
  private static readonly captchaElements = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890';

  private static getRandomIntInclusive(min: number, max: number): number {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  private static generateCaptchaString(length: number): string {
    let captcha = '';
    const maxIndex = this.captchaElements.length - 1;
    while (length-- > 0) {
      const index = this.getRandomIntInclusive(0, maxIndex);
      captcha += this.captchaElements[index];
    }
    return captcha;
  }

  /**
   * Generates a CAPTCHA image inside the element with ID 'captcha'
   * and returns the generated string for verification.
   */
  public captchaGenerator(): string {
    const captcha = CaptchaService.generateCaptchaString(6);

    const canvas = document.createElement('canvas');
    canvas.id = 'captchaImg';
    canvas.width = 120;
    canvas.height = 30;
    canvas.style.pointerEvents = 'none';

    const ctx = canvas.getContext('2d');
    if (ctx) {
      ctx.font = '20px serif';
      ctx.strokeText(captcha, 22, 21);
    }

    const container = document.getElementById('captcha');
    if (container) {
      const oldCanvas = document.getElementById('captchaImg');
      if (oldCanvas) {
        container.removeChild(oldCanvas);
      }
      container.appendChild(canvas);
    } else {
      console.warn("Element with ID 'captcha' not found in DOM.");
    }

    return captcha;
  }
}
